<!-- src/components/SiteFooter.vue -->
<template>
  <footer class="bg-[#fff] text-[#545c63] border-t border-gray-200 text-sm">
    <div class="max-w-screen-xl mx-auto px-5 py-7 md:py-8 flex flex-col gap-3.5">
      <!-- 导航 -->
<!--      <nav class="flex flex-wrap justify-center gap-x-6 gap-y-4">-->
<!--        <router-link-->
<!--            to="/"-->
<!--            class="no-underline hover:text-indigo-600 transition-colors"-->
<!--            exact-active-class="text-indigo-600"-->
<!--        >-->
<!--          首页-->
<!--        </router-link>-->
<!--        <router-link-->
<!--            to="/about"-->
<!--            class="no-underline hover:text-indigo-600 transition-colors"-->
<!--            exact-active-class="text-indigo-600"-->
<!--        >-->
<!--          关于我们-->
<!--        </router-link>-->
<!--        <router-link-->
<!--            to="/products"-->
<!--            class="no-underline hover:text-indigo-600 transition-colors"-->
<!--            exact-active-class="text-indigo-600"-->
<!--        >-->
<!--          产品服务-->
<!--        </router-link>-->
<!--        <router-link-->
<!--            to="/cases"-->
<!--            class="no-underline hover:text-indigo-600 transition-colors"-->
<!--            exact-active-class="text-indigo-600"-->
<!--        >-->
<!--          客户案例-->
<!--        </router-link>-->
<!--        <router-link-->
<!--            to="/contact"-->
<!--            class="no-underline hover:text-indigo-600 transition-colors"-->
<!--            exact-active-class="text-indigo-600"-->
<!--        >-->
<!--          联系我们-->
<!--        </router-link>-->
<!--        <a-->
<!--            href="https://www.miit.gov.cn/"-->
<!--            target="_blank"-->
<!--            rel="noopener"-->
<!--            class="no-underline hover:text-indigo-600 transition-colors"-->
<!--        >-->
<!--          工信部-->
<!--        </a>-->
<!--      </nav>-->

      <!-- 联系方式 -->
      <div class="flex flex-col md:flex-row flex-wrap justify-center items-center gap-x-8 gap-y-2 text-[#666]">
        <span>客服电话：400-000-1235</span>
        <span>地址：福建省福州市闽侯县高新区三松浦玉B座1206</span>
      </div>

      <!-- 备案/版权 -->
      <div class="flex flex-wrap justify-center items-center gap-x-4 gap-y-3 text-[#888] text-xs">
        <span>© 2017-2025 福州七云智联智能科技有限公司</span>

        <a
            class="no-underline hover:text-indigo-600 transition-colors"
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener"
        >
          闽ICP备2024066733号-3
        </a>

        <a
            class="inline-flex items-center gap-1.5 no-underline hover:text-indigo-600 transition-colors"
            href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35018302000244"
            target="_blank"
            rel="noopener"
            aria-label="公网安备备案"
        >
          <svg viewBox="0 0 1024 1024" class="w-[14px] h-[14px]" aria-hidden="true">
            <path d="M512 64l384 192v224c0 256-160 416-384 480C288 896 128 736 128 480V256L512 64z" fill="#999" />
          </svg>
          闽公网安备 35018302000244 号
        </a>
      </div>
    </div>
  </footer>
</template>

<script setup>
// 纯静态，无需脚本
</script>

<style>

</style>